var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWellness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.00146L20.9913 2.87441C25.3764 6.7359 28.1432 11.5247 29.2507 16.5685C31.8819 15.2453 34.8539 14.5002 38 14.5002H39.5V16.0002C39.5 26.2651 31.5687 34.6775 21.5 35.4434V35.5002H20H18.5V35.4434C8.43133 34.6775 0.5 26.2651 0.5 16.0002V14.5002H2C5.14606 14.5002 8.1181 15.2453 10.7493 16.5685C11.8568 11.5247 14.6236 6.7359 19.0087 2.87441L20 2.00146ZM13.4812 18.2369C16.3437 20.3253 18.6157 23.1745 20 26.487C21.3843 23.1745 23.6563 20.3253 26.5188 18.2369C25.7847 13.8556 23.625 9.5955 20 6.0462C16.375 9.5955 14.2153 13.8556 13.4812 18.2369ZM36.4259 17.5744C35.6824 25.4306 29.4303 31.6826 21.5741 32.4261C22.3176 24.5699 28.5697 18.3179 36.4259 17.5744ZM18.4259 32.4261C10.5697 31.6826 4.31764 25.4306 3.57411 17.5744C11.4303 18.3179 17.6824 24.5699 18.4259 32.4261Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.b467648b851bef233570f38019a63d00.svg";
export { ForwardRef as ReactComponent };